import React from "react";
import { NoPage } from "../../components/commons";

const DashboardModule = () => {
  return <NoPage />;
};

export default DashboardModule;
